<template>
  <div class="l-app">
    <loader :loading="loading || !user"/>
    <server-error v-if="hasError"/>
    <template v-if="!loading && user && !hasError && !hasAccessError">
      <div>
        <sidebar>
          <div class="logo" slot="start">
            <img src="/static/images/logo.png" alt="Logo">
          </div>

          <menu-sidebar v-menu slot="content"/>
        </sidebar>
        <div class="l-app__content">
          <header class="l-app__topbar top-bar">
            <nav class="c-navbar c-navbar--light">

              <div class="c-navbar__left">
                <a role="button" class="c-navbar__item u-hiddenUp@md" v-toggle:sidebar>
                  <i class="i-menu i-menu--light"></i>
                </a>
              </div>
              <menu-top-bar/>
            </nav>
            <!-- END .c-navbar -->
          </header>
          <div class="l-app__body">
            <main class="l-app__main">
              <breadcrumb ref="breadcrumb"/>
              <router-view/>
            </main>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import Loader from '@/components/template/Loader'
  import ServerError from '@/components/template/ServerError'
  import Cookie from 'vue-cookie'
  import api from '@/api'
  import storage from '@/storage'
  import MenuSidebar from '@/components/template/MenuSidebar'
  import MenuTopBar from '@/components/template/MenuTopBar'
  import Breadcrumb from '@/components/template/Breadcrumb'
  import { mapFields } from 'vuex-map-fields'

  export default {
    provide: {
      expeditersDI: storage.expediter,
      priceTypeDI: storage.priceType
    },
    data: () => ({
      hasError: false,
      loading: true,
      chatStarted: false,
      merchant: null
    }),
    async mounted () {
      await this.validateAuthentication()

      try {
        this.merchant = await api.getMerchant(Cookie.get('merchant'))
        await this.fetch()
      } catch (err) {
        this.loading = false
      }

      if (this.user) {
        this.initChat()
      }

      await this.removeAccessTokenUrl()
    },
    methods: {
      ...mapActions('module', [
        'fetch'
      ]),
      ...mapActions('user', [
        'addUser',
        'changeMerchant',
        'login'
      ]),
      async validateAuthentication () {
        await this.login()
        this.loading = false
      },
      async removeAccessTokenUrl () {
        const currentUrl = window.location.href
        if (currentUrl.indexOf('?access_token') !== -1) {
          this.loading = true
          const url = currentUrl.replace(currentUrl.substr(currentUrl.indexOf('?'), 140), '')
          window.location.replace(url)
        } else {
          this.loading = false
        }
      },
      async initChat () {
        if (this.chatStarted) {
          return
        }

        try {
          // eslint-disable-next-line no-undef,camelcase
          if (Tawk_API) {
            // eslint-disable-next-line no-undef
            Tawk_API.showWidget()

            // eslint-disable-next-line no-undef
            Tawk_API.setAttributes({
              'name': this.merchant.name,
              'email': this.user.email
            })

            this.chatStarted = true
          }
        } catch (e) {
        }
      }
    },
    watch: {
      '$route' () {
        // eslint-disable-next-line no-undef,camelcase
        if (Tawk_API) {
          // eslint-disable-next-line no-undef
          Tawk_API.addEvent('mudou-de-pagina', {
            'page': `https://panel.placemarket.com.br/#${this.$router.history.current.fullPath}?merchant=${Cookie.get('merchant')}`
          })
        }

        this.$refs.breadcrumb.init()
      },
      user () {
        this.initChat()
      }
    },
    computed: {
      ...mapFields({
        user: 'user.user',
        logging: 'user.logging',
        hasAccessError: 'user.hasAccessError'
      }),
      getUrlPanelV2 () {
        if (!this.user.authentication) {
          return false
        }

        return `${process.env.ACTION_CENTER_URL}?token=${this.user.authentication.token}`
      }
    },
    components: {
      Loader,
      ServerError,
      MenuSidebar,
      MenuTopBar,
      Breadcrumb
    }
  }
</script>

<style lang="sass" scoped>
  .top-bar
    z-index: 10
  .logo
    height: 50px

  .c-navbar
    align-items: center

  .l-app
    flex-direction: column

    > div
      display: flex

      &:last-child
        overflow-x: auto
        height: 100%

  .notification
    display: flex
    align-items: center
    justify-content: center
    margin: 0

    .new-panel-icon
      color: #ffc800

    > a
      color: #8a6d3b
</style>



// WEBPACK FOOTER //
// Layout.vue?1650063b